var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAloneMarginLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#BFBFBF",
    t: 1641387449807,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 25350,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M545.28 300.8l-211.2 211.2 211.2 211.2-60.373333 60.373333L213.333333 512l271.573334-271.573333zM725.333333 768h85.333334V256h-85.333334z",
    "p-id": 25351
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAloneMarginLeft);
export default __webpack_public_path__ + "static/media/alone-margin-left.3e6defd5e6f4eb6472bd20372d1f702f.svg";
export { ForwardRef as ReactComponent };